import React, { useEffect } from 'react'
import { useNavigate } from 'react-router-dom';

function AuthCheck({ cmp, baseUrl }) {

    const navigate = useNavigate();

    let Cmp = cmp;

    useEffect(() => {

        if (!localStorage.getItem('authToken')) {
            navigate('/login')
        }
    }, [])
    return (
        <>
            <>
                <Cmp baseUrl={baseUrl} />
            </>
        </>
    )
}

export default AuthCheck